import { Component, OnInit } from '@angular/core';
import { ExcTranslation} from 'exc-core';
import {OverlayConfig, OverlayRef} from 'exc-controls';
import {ExcSigninService} from 'exc-signin';
import {DatePipe} from '@angular/common';
import {DefaultSettingsService} from '../../../default-settings-service.service';

@Component({
  selector: 'app-client-modal-audit-cancel',
  templateUrl: './client-modal-audit-cancel.component.html',
  providers: [DatePipe],
  styles: []
})
export class ClientModalAuditCancelComponent extends ExcTranslation implements OnInit {
 selectedCancellationReason = null;
 cancellationReasons = null;
 comment = null;
  constructor(
    public overlayConfig: OverlayConfig,
    public overlayRef: OverlayRef,
    private excSec: ExcSigninService,
    private datePipe: DatePipe,
    private excDss: DefaultSettingsService
  ) {
    super();
    const _self = this;
  }
  ngOnInit() {
    const _self = this;
    _self.cancellationReasons = this.getEnumerationStornoGrund();
  }
  getEnumerationStornoGrund(): any[] {
    return this.excDss.Enumeration.filter((enm: any) => enm.enmName === 'enum_Stornogrund');
  }
  proceed() {
    const _self = this;
    let comment = '';
    comment = _self.getRessource('CommentSchemeReason', {date: _self.datePipe.transform((new Date()), _self.getGlobal('FormatDateTime'))
                                                                , user: _self.excSec.Profile.DisplayName
                                                                , reason: this.comment});
    _self.overlayRef.close({proceed: true, CancellationReason: _self.selectedCancellationReason, Comment: comment});
  }
  cancel() {
    const _self = this;
    _self.overlayRef.close({proceed: false, CancellationReason: null, Comment: null});
  }
}
